/*****
 * Created by Allan on 2021/11/05.
 * Contact 84880528@qq.com.
 * 全局
 * *****/
import { Base64 } from 'js-base64'
import getQueryVariable from '@/baseloan/service/getQueryVariable'
import Http from '@/baseloan/service/http/'
export default{
    state:{
        downloadInfo:JSON.parse(localStorage.getItem(`${Base64.decode(getQueryVariable('b'))}Download`)) || {}, //APP下载信息
    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        downloadInfo:state=>state.downloadInfo,
    },
    //state 作为第一个参数
    mutations:{
        setDownloadInfo(state,data){
            localStorage.setItem(`${Base64.decode(getQueryVariable('b'))}Download`,JSON.stringify(data));
            state.downloadInfo=data;
        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        getDownloadInfo({commit},params){
            return new Promise((resolve,reject)=>{
                Http('/skip/app/v1/downloadInfo',{method:'post',data:params,reqType:'json'}).then(res=>{
                    console.log('app下载信息',res);
                    commit('setDownloadInfo',res.data)
                    resolve(res.data)
                }).catch((e) => {
                    reject(e)
                })
            })
        },
    },
}












// WEBPACK FOOTER //
// ./src/baseloan/store/module/global.js